function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M60.335 35.55c0 2.275-1.959 4.119-4.375 4.119a4.61 4.61 0 01-1.498-.248",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.046 46.644l3.875 3.845 7.75-7.69c1.979-1.866 3.186-4.427 3.186-7.274 0-4.488-3.043-8.306-7.29-9.721M11.665 35.55c0 2.275 1.959 4.119 4.375 4.119a4.61 4.61 0 001.498-.248",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.955 46.644l-3.875 3.845-7.75-7.69c-1.98-1.866-3.187-4.427-3.187-7.274 0-4.488 3.044-8.306 7.291-9.721",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M46.271 66.269c-1.245.24-2.58.439-3.987.589m-12.567 0c-7.826-.833-13.465-3.178-13.465-5.94 0-2.146 3.4-4.04 8.586-5.169m22.325 0c5.185 1.129 8.586 3.023 8.586 5.168 0 .912-.614 1.778-1.717 2.559M46.001 44.399c-3.526 4.898-7.234 9.013-9.205 11.104a1.874 1.874 0 01-2.795-.043c-4.179-4.78-16.515-19.829-16.515-30.877 0-10.736 8.313-19.44 18.568-19.44 9.576 0 17.458 7.589 18.46 17.336m-3.547 14.04a43.384 43.384 0 001.632-3.41m1.716-5.457c-.063.336-.137.675-.219 1.015",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.874 23.657c0 5.454-4.42 9.875-9.874 9.875-5.453 0-9.874-4.421-9.874-9.874 0-5.454 4.42-9.875 9.874-9.875",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAssociations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "/img/associations.svg";
export { SvgAssociations as ReactComponent };